import { render } from "./lovePerson.vue?vue&type=template&id=29f1e5ae"
import script from "./lovePerson.vue?vue&type=script&lang=js"
export * from "./lovePerson.vue?vue&type=script&lang=js"

import "./lovePerson.vue?vue&type=style&index=0&id=29f1e5ae&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__